import React from "react";
const NavigationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M17.4682 2.5L2.53906 8.70547L8.71456 11.2836L11.1728 17.4591L17.4682 2.5Z" fill="#339586"/>
	</svg>
);
export default NavigationIcon;
